import { gql } from '@apollo/client';

export const getTerritoryHeaderDataQuery = gql`
  query territory($territoryId: ID!) {
    territory(where: { id: $territoryId }) {
      id
      name
      slug
      version
      territoryImage {
        id
        publicUrl
        publicUrlTransformed
        _meta {
          public_id
          height
          width
        }
      }
      createdAt
      logo {
        id
        publicUrl
        publicUrlTransformed
      }
      description
      articlesCount(where: { status: { equals: "published" }, type: { equals: ARTICLE } })
      totalTimePoints
      membershipsCount(where: { status: { equals: ACTIVE } })
      memberships(take: 50, where: { status: { equals: ACTIVE } }) {
        id
        user {
          id
          name
          publicAddress
          username
          cumulativeTimePoints
          profileImage {
            id
            publicUrl
            publicUrlTransformed
            _meta {
              public_id
              height
              width
            }
          }
        }
      }
    }
  }
`;
